class TeamDMDropdownController {

	initialize() {
		this.teamDMDropdown();
	}

	teamDMDropdown() {
		const teamDMDropdown = document.getElementById('js-team-dm-dropdown');
		const toggleLabel = document.querySelector('.js-team-dm-dropdown-bar-toggle-label');
		const toggleCheckbox = document.getElementById('team-dm-dropdown-toggle');
		const navigation = document.querySelector('.navigation');
		const mobileHamburgerButton = document.getElementById('js-mobile-hamburger-button');

		if (teamDMDropdown) {
			// Team DM Drop Down -> Make enter key press on label trigger dropdown
			toggleLabel.addEventListener('keypress', (e) => {
				if (e.keyCode === 13) { // If the the enter key was pressed.
					toggleCheckbox.click();
				}
			});

			// Close the Team DM Drop down if clicking outside
			window.addEventListener('click', (e) => {
				if (!teamDMDropdown.contains(e.target)) {
					if (toggleCheckbox.checked) {
						toggleCheckbox.click();
					}
				}
			});

			// Close mobile hamburger menu and allow scrolling when team dm dropdown is open
			toggleCheckbox.addEventListener('change', (e) => {
				if (e.currentTarget.checked) {
					if (navigation.classList.contains('is-expanded-mobile-in')) {
						mobileHamburgerButton.click();
					}
				}
			});
		}
	}

}

export default new TeamDMDropdownController();
